export const API = {
    POST: {
        async registerAccount(csrfToken, payload) {
            return await fetch('/account/register/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },

        async checkSchoolByConstituentId(csrfToken, payload) {
            return await fetch('/account/school-check', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },

        async login(csrfToken, payload) {
            return await fetch('/account/login/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },
        async constituent(csrfToken, payload) {
            return await fetch('/account/create-constituent/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            })
        },

        async sessionCreate() {

            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

            return await fetch('/account/session/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'include',
            });
        },

        async logout(csrfToken) {
            return await fetch('/account/logout/', {
                method: 'POST',
                headers: {
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'include',
            });
        },

        async membershipCreate(csrfToken, constituentId, payload) {
            return fetch(`/account/membership-create/${constituentId}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },
        async affiliation(csrfToken, constituentId, payload) {
            console.log(payload);
            return fetch(`/account/affiliation/${constituentId}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },
        async addToBasket(csrfToken, payload) {
            return await fetch('/account/add-to-basket/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },

        async createManualBenefitUsage(csrfToken, payload) {
            return await fetch('/account/manual-benefit-usage/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },
        sessionTransfer(csrfToken, payload) {
            return fetch('/account/session/transfer/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'include',
            });
        },
        createAddress(csrfToken, payload) {
            return fetch('/account/create-address/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },
        inviteUser(csrfToken, payload) {
            return fetch('/account/invite-user/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        }
    },

    GET: {
        async accountLookup(email) {
            return await fetch(`/account/lookup/?email=${encodeURIComponent(email)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        },
        async constituentSearch(query) {
            const qs = new URLSearchParams(query).toString();
            return await fetch(`/account/constituent-search/?${qs}`);
        },
        async constituent(constituentId) {
            return await fetch(`/account/constituent-detail/${constituentId}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        },
        async countries() {
            return await fetch('/account/countries/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        },
        async states() {
            return await fetch('/account/states/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        },
        async sessionData(constituentId) {
            return await fetch('/account/session-status/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                query: new URLSearchParams({constituentId}),
                credentials: 'include',
            });
        },
        async membershipSummary(constituentId) {
            return await fetch(`/account/membership-summary/${constituentId}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        },
        async checkNumberOfSeatsForMembership(constituentId) {
            return await fetch(`/account/benefits-number-of-seats/${constituentId}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        },
        async affiliations(query) {
            const qs = new URLSearchParams(query).toString();

            return await fetch(`/account/affiliations/?${qs}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        },
        async membershipOrganisationBenefitSummary(membershipOrganisationId) {
            return await fetch(`/account/membership-organisation-benefit-summary/${membershipOrganisationId}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        },
        async fetchOrders(sessionId) {
            return await fetch(`/account/cart/orders/?sessionId=${sessionId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });
        },
        async fetchAttributes(constituentId, query) {
            const qs = new URLSearchParams(query).toString();
            return await fetch(`/account/attributes/${constituentId}/?${qs}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });
        }
    },

    PUT: {
        async updatePassword(csrfToken, payload) {
            return await fetch('/account/update-password/', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },
        async updateProfile(csrfToken, payload) {
            return await fetch('/account/update-profile/', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },
        async updateManualBenefitUsage(csrfToken, payload) {
            return await fetch('/account/manual-benefit-usage/', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        },

        async updateAddress(csrfToken, addressId, payload) {
            return await fetch(`/account/update-address/${addressId}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(payload),
            });
        }
    },

    PATCH: {},

    DELETE: {
        async affiliation(csrfToken, constituent_id) {
            return await fetch(`/account/affiliation/${constituent_id}/delete`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
            });
        },
    },
};
